export default "__VITE_ASSET__2c7f20b1__"